import { createContext, useContext } from 'react';

/**
 * The element covering the main content area (left of the global chat). A
 * drawer opened from a page portals into it, so it slides over the page while
 * the chat stays visible and usable beside it.
 */
export const MainOverlayContext = createContext<HTMLElement | null>(null);

export const useMainOverlay = () => useContext(MainOverlayContext);
